import * as React from "react"
import styled from "styled-components"
import {GatsbyImage, getImage} from "gatsby-plugin-image"
import frameImage from "../../resources/img/bamboo-panels/frame.png";
import breakpoints from "../../styles/breakpoints";

const ImageContainer = styled.div`
  display: block;
  width: 100%;
  position: relative;
  margin: 0 auto 72px auto;
  max-width: 295px;
  height: 155px;

  @media (min-width: ${breakpoints.sm}) {
    max-width: 375px;
    height: 198px;
  }
  
  @media (min-width: ${breakpoints.xl}) {
    margin: 0 auto 120px auto;
    max-width: 100%;
    height: 505px;
  }
`;

const FrameContainer = styled.div`
  background: url("${frameImage}") no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 155px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;

  @media (min-width: ${breakpoints.sm}) {
    height: 198px;
  }
  
  @media (min-width: ${breakpoints.xl}) {
    height: 505px;
  }
`;

const BackgroundImageContainer = styled.div`
  width: 100%;
  height: 155px;
  padding: 8px;
  overflow: hidden;
  z-index: 1;
  position: relative;

  @media (min-width: ${breakpoints.sm}) {
    height: 198px;
  }
  
  @media (min-width: ${breakpoints.xl}) {
    height: 500px;
    padding: 14px 20px;
  }
`

const BackgroundImage = styled(GatsbyImage)`
  display: block !important;
  max-width: 100%;
  object-fit: cover;
  width: 100%;
  height: 100%;
`

const StyledArticleImage = styled(GatsbyImage)`
  display: block !important;
  width: auto;
  max-width: 100%;
  margin: 0 auto 40px auto;
`

const ArticleImage = ({image, frame}) => {
  return (
    <>
      {frame ?
        <ImageContainer>
          <FrameContainer />
          <BackgroundImageContainer>
            <BackgroundImage image={getImage(image)} loading={"lazy"} />
          </BackgroundImageContainer>
        </ImageContainer>
        :
        <StyledArticleImage image={getImage(image)} loading={"lazy"}/>
      }
    </>
  )
}

export default ArticleImage;
